import { Button } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';

import Icon from '@components/Icon/Icon';

interface AddRecordProps {
  route: string;
  text: string;
}

export default function AddRecord({ route, text }: AddRecordProps) {
  return (
    <Button
      onClick={() => navigate(route)}
      startIcon={<Icon name="plus" type="fas" />}
      sx={{
        border: ({ palette }) => `1px solid ${palette.info.main}`,
        color: ({ palette }) => palette.info.main,
        textTransform: 'capitalize',
        fontSize: 14,
      }}
      variant="outlined"
    >
      {text}
    </Button>
  );
}
